import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { Chart, registerables } from 'chart.js';
import { Constant } from '../../../blog/constant';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'asset-distribution',
  templateUrl: './asset-distribution.html',
  styleUrls: ['./asset-distribution.scss'],
})
export class AssetDistribution implements OnInit, OnChanges {
  @Input('assetDistribution') assetDistribution: any;
  @Input('updateTime') updateTime: any;
  data: any = [{ name: '', value: '' }];
  colorScheme: any = {
    domain: [],
  };
  view: [number, number] = [500, 300];
  chart: any;
  @Input() chartData: any = {
    labels: ['title'],
    datasets: [
      {
        label: 'label',
        data: [13],
        backgroundColor: [' '],
      },
    ],
  };
  constructor(private translateService: TranslateService) {}

  ngOnInit() {
    Chart.register(...registerables);
  }
  ngOnChanges(simpleChanges: SimpleChanges) {
    const changes: any = simpleChanges;
    if (changes.assetDistribution) {
      setTimeout(() => {
        this.createChart();
      }, 2000);
    }
  }
  setData() {
    this.assetDistribution = this.assetDistribution || [];
    this.data = this.assetDistribution.map((item: any) => {
      return {
        name: item.assetType.name,
        value: item.assetPercent,
      };
    });
    this.colorScheme = {
      domain: this.assetDistribution.map(
        (item: any) => item.assetType.colorCode
      ),
    };
  }
  createChart() {
    if (this.chart) {
      this.chart.destroy();
    }
    this.assetDistribution = this.assetDistribution || [];
    this.chart = new Chart('pieChart', {
      type: 'pie',
      data: {
        labels: this.assetDistribution.map((item: any) => item.assetType.name),
        datasets: [
          {
            label: this.translateService.instant('Tỉ trọng(%)'),
            data: this.assetDistribution.map((item: any) => item.assetPercent),
            backgroundColor: this.assetDistribution.map(
              (item: any) => item.assetType.colorCode
            ),
          },
        ],
      },
      options: {
        responsive: true,
        plugins: {
          tooltip: {
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            bodyFont: {
              size: 14,
            },
            titleFont: {
              size: 16,
              weight: 'bold',
            },
          },
          legend: {
            display: false,
          },
          datalabels: {
            color: 'white',
            font: {
              weight: 'bold',
            },
          },
        },
      },
    });
  }
}
